import SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol';
import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';
import { getColorValue } from '.';

export const createPointSymbol = (
  boundaryColor = '',
  pointColor = '',
): SimpleMarkerSymbol => {
  const boundaryRGB = getColorValue(boundaryColor);
  const pointRGB = getColorValue(pointColor);

  return new SimpleMarkerSymbol({
    color: [...pointRGB, 0.8],
    outline: new SimpleLineSymbol({
      color: boundaryRGB,
      width: 2,
    }),
    size: 12,
    style: 'circle',
  });
};
